import { Modal, Spin as SpinAntd } from 'antd';
import styled from 'styled-components';

import colors from '../../../../../styles/colors';

export const Container = styled.div`
  margin: 30px 0;

  display: flex;
  flex-direction: row;
  align-items: center;

  > p {
    margin: 0;
    margin-right: 20px;
  }

  > button {
    margin-right: 15px;
    transition: background 0.1s;
  }
`;

export const CustomModal = styled(Modal)`
  display: flex;
  flex-direction: column;

  .ant-modal-footer {
    display: flex;
    justify-content: flex-end;
  }
`;

export const FieldContainer = styled.div`
  margin-bottom: 24px;

  p {
    margin: 0;
    margin-bottom: 4px;
  }

  button {
    transition: background 0.1s;
  }
`;

export const AgendamentoContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const AgendamentoInfo = styled.div`
  padding: 9px 16px;
  background: ${colors.$auxiliary_yolk_4};
  border: 1px solid ${colors.$calendula_gold_3};

  p {
    margin: 0;
  }
`;

export const AvisoValidar = styled.h4`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.025em;

  margin-top: -16px;

  color: #d42929;
`;

export const Spin = styled(SpinAntd)`
  width: 100%;

  .ant-spin-dot-item {
    background-color: #24a95d !important;
  }
`;
